import React from 'react';
import {Switch, Route, BrowserRouter} from 'react-router-dom';
import routes from "../routes";
import MainPage from "../views/main";
import MainLivePage from "../views/live";

const Layout = () => {

    const menu = routes.map((route, index) => {
        return (route.component) ? (
            <Route
                key={index}
                path={route.path}
                exact={route.exact}
                name={route.name}
                component={route.component}/>
        ) : null;
    });
    return (
        <BrowserRouter>
            <Switch>
                {menu}
                <Route path="/" component={MainPage}/>
                <Route path="/xo-so-truc-tiep-duc-hanh.php" component={MainLivePage}/>
            </Switch>
        </BrowserRouter>
    );
};


export default Layout;
